import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-265d0af9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "office-summary" }
const _hoisted_3 = { class: "text-size-14" }
const _hoisted_4 = { class: "pl-2 py-2" }
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "報酬", -1))
const _hoisted_7 = { class: "text-mild text-size-14" }
const _hoisted_8 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "交通費", -1))
const _hoisted_10 = { class: "text-mild text-size-14" }
const _hoisted_11 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "源泉徴収額", -1))
const _hoisted_13 = { class: "text-mild text-size-14" }
const _hoisted_14 = { class: "d-flex justify-content-between mt-2 px-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500" }, "総計", -1))
const _hoisted_16 = { class: "text-blue text-size-16 text-weight-500" }

import { formatCurrency } from "@/utils/number";
import { CorporationSalarySummary } from "@/types/balance/BalanceHistory";
import { computed, PropType } from "vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalaryDetailModal',
  props: {
  isShowDetailModal: {
    type: Boolean,
    default: false
  },
  corporationSalarySummary: {
    type: Object as PropType<CorporationSalarySummary>,
    required: true
  }
},
  emits: ["close"],
  setup(__props, { emit: emits }) {

const props = __props;



const isShown = computed(() => props.isShowDetailModal);

function onClose() {
  emits("close");
}

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createBlock(_component_BModal, {
    modelValue: isShown.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShown).value = $event)),
    title: "給与明細内訳",
    "hide-footer": "",
    centered: "",
    class: "detail-modal",
    onClose: onClose,
    onHide: onClose
  }, {
    default: _withCtx(() => [
      (__props.corporationSalarySummary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.corporationSalarySummary.officeSalarySummaries, (officeSalarySummary) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'office-summary' + officeSalarySummary.officeId,
                  class: "office-summary-item"
                }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(officeSalarySummary.name), 1),
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createTextVNode(),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(formatCurrency)(officeSalarySummary.reward)), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createTextVNode(),
                      _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formatCurrency)(officeSalarySummary.optionValue)), 1)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(),
                      _createElementVNode("p", _hoisted_13, "\n                - " + _toDisplayString(_unref(formatCurrency)(officeSalarySummary.withholdingTax)), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(formatCurrency)(__props.corporationSalarySummary.totalIncome)), 1)
            ]),
            _createTextVNode(),
            _createVNode(AppButtonOutline, {
              block: "",
              class: "text-primary-dark text-weight-500 mt-3",
              onClick: onClose
            }, {
              default: _withCtx(() => [
                _createTextVNode("閉じる")
              ], undefined, true),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }, 8, ["modelValue"]))
}
}

})